import * as React from 'react';

import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';

import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

type Props = {
    existingMeeting: Meeting | null | undefined;
};

export function CreateMeetingModalHeading(props: Props) {
    return props.existingMeeting ? (
        <div>
            <div className='mb-8'>
                <Header>Add co-host(s)</Header>
            </div>
            <Body>
                This meeting will be duplicated as <strong>co-hosted</strong>
                {!props.existingMeeting.cohosts.length && (
                    <>
                        {' '}
                        instead of <strong>solo</strong>
                    </>
                )}
                .
            </Body>
        </div>
    ) : (
        <Header>Create new meeting</Header>
    );
}
